<template>
  <div :style="{height:Height+'px',width:Width+'px'}">
    <!--:class="{'isMin': isMin?'auto':''}"-->
    <!--第一行-->
    <div class="box margin-all box-btw" style="height:42.6%">
      <!--第一行的左边部分-->
      <she-qu style="margin-right: 18px;" :height="height1" :width="Width" :shequ="shequ"></she-qu>
      <!--第一行的右边部分-->
      <div class="box_f1 box_v" :style="{width:Width*0.66875+'px'}">
        <!--第一行的右边的上半部分-->
        <Head :count="count"></Head>
        <!--第一行的右边的下半部分-->
        <div class="box_f1 box box-btw" style="align-items: flex-end;">
          <weizhibu :height="height1" :width="Width" :zhibu="zhibu"></weizhibu>
          <zhiyuanzhe :height="height1" :width="Width" :score="score"></zhiyuanzhe>
        </div>
      </div>
    </div>
    <!--第二行-->
    <div class="margin-right margin-left box box-btw" style="height: 21.5%;">
      <she-gong :height="height2" :width="Width" :shegong="shegong"></she-gong>
      <dang-yuan :height="height2" :width="Width" :partyMessage="partyMessage"></dang-yuan>
      <min-yi :height="height2" :width="Width" :eventReport="eventReport"></min-yi>
    </div>

    <!--第三行-->
    <div class="margin-all box box-btw" style="height: 30.2%;margin-bottom: 0">
      <shi-jian :height="height3" :width="Width" :shijianEc="shijianEc" ></shi-jian>
      <shequhuodong :height="height3" :width="Width" :active="active" :bmarr="bmarr"></shequhuodong>
      <shenghuofuwu :height="height3" :width="Width" :fuwuEc="fuwuEc"></shenghuofuwu>
    </div>
  </div>
</template>

<script>
  var that
  import sheQu from './components/shequ'
  import sheGong from './components/shegong'
  import shiJian from './components/shijian'
  import Head from './components/head'
  import dangYuan from './components/dangyuan'
  import minYi from './components/minyi'
  import zhiyuanzhe from './components/zhiyuanzhe'
  import shenghuofuwu from './components/shenghuofuwu'
  import weizhibu from './components/weizhibu'
  import shequhuodong from './components/shequhuodong'

  export default {
    inject: ['reload'],
    components: {
      sheQu,
      sheGong,
      shiJian,
      Head,
      dangYuan,
      minYi,
      zhiyuanzhe,
      shenghuofuwu,
      weizhibu,
      shequhuodong,

    },
    data() {
      return {
        Height: window.document.body.offsetHeight - 60 - 20,
        Width: window.document.body.offsetWidth,
        isMin: false,
        shequ: {
          title: '',
          info: []
        },//社区信息
        count: {},//数据统计
        score: [],//热心居民 积分前10
        zhibu: [],//微支部 数组
        shegong: [],//社工办理
        partyMessage: [],//党员动态
        eventReport: [],//民意直通车  上报的事件
        active: {
          cover: '',
          title: '',
          sponsorName: '',//主办方
        },//社区活动
        bmarr: [],//报名人
        shijianEc: null,//事件办理echarts
        fuwuEc: null,//生活服务echarts
      }
    },
    computed: {
      height1() {
        return this.Height * 0.436 + ''
      },
      height2() {
        return this.Height * 0.215 + ''
      },
      height3() {
        return this.Height * 0.302 + ''
      }
    },
    mounted: function () {
      that = this
      window.addEventListener('resize', this.handleResize)
      this.Height = window.document.body.offsetHeight - 60 - 20
      this.getData()
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      handleResize(event) {
        this.Height = document.documentElement.clientHeight - 60
        this.Width = window.document.body.offsetWidth
        if (this.Height < 700) {
          this.Height = 700;
        }
      },
      getData() {
        var getInfo = this.getInfo()
        var getCount = this.getCount()
        var getScore = this.getScore()
        var getParty = this.getParty()
        var getEvent = this.getEvent()
        var getPartyMes = this.getPartyMes()
        var getEventReport = this.getEventReport()
        var getActive = this.getActive()
        var getShijianEc = this.getShijianEc()
        var getFuwuEc = this.getFuwuEc()
        if (sessionStorage.shouFirst == 1) {
          this.$store.commit("updateSpinShow", true);
        }
        Promise.all([getInfo, getCount, getScore, getParty, getEvent, getPartyMes, getEventReport, getActive, getShijianEc, getFuwuEc]).then(res => {
          this.$store.commit("updateSpinShow", false);
          sessionStorage.shouFirst = 0
          //处理 社区信息 数据
          var infoRes = res[0].rows[0]
          var shequ = {
            title: infoRes.communityName,
            headPic:infoRes.headPicUrl,
            info: [{
              str: infoRes.introduction
            }]
          }
          infoRes.picList.forEach(item => {
            shequ.info.push({
              img: item
            })
          })
          this.shequ = shequ

          //处理 数量统计 数据
          var countRes = res[1].rows[0]
          this.count = {
            company: countRes.companyCount,//企业总数
            worker: countRes.workerCount,//社工总数
            eventTotal: countRes.eventCount,//事件总数
            eventTodo: countRes.todoCount,//待办数
            peopleTotal: countRes.residentSysCount,//居民总数
            peopelRealname: countRes.residentRealCount,//实名认证居民数
          }
          //处理热心居民数据
          this.score = res[2].rows.slice(0, 10).map(item => {
            return {
              name: item.userName,
              headPic: item.headPicUrl
            }
          })
          //处理微支部 数据
          this.zhibu = res[3].rows.map(item => {
            return {
              name: item.zone_name,//支部名称
              pic: item.picPath,//支部图片
              count: item.userCount,//支部人数
              id: item.id,//支部id
              userName: item.userName ? item.userName : '暂无管理员',//支部管理员
            }
          })
          //处理 社工办理 数据
          this.shegong = res[4].rows.slice(0, 10).map(item => {
            return {
              name: item.realName ? item.realName : item.userName,
              headPic: item.headPicUrl,
              content: item.content
            }
          })
          //处理 党员动态 数据
          this.partyMessage = res[5].rows.map(item => {
            return {
              name: item.userName,
              content: item.message,
              headPic: item.headPicUrl
            }
          })
          //处理  民意直通车 数据
          this.eventReport = res[6].rows.map(item => {
            return {
              file: item.files,
              name: item.userName,
              content: item.content
            }
          })
          //处理  活动 数据
          if (res[7].rows.length) {
            var req = res[7].rows[0].detail;
            this.active = {
              cover: req.coverPicUrl,
              title: req.title,
              sponsorName: req.zoneName,//主办方
            };
            this.bmarr = res[7].rows[0].applyUserList
              .map(item => {
                return {
                  headPicUrl: item.headPicUrl,
                  userName: item.userName || "游客",
                  time:
                    typeof item.recordTime == "string"
                      ? item.recordTime
                      : that.$util.FormatDate(
                      Number(item.recordTime),
                      "MM-dd  HH:mm"
                      )
                };
              });
          }
          //处理事件echarts数据
          var ec1 = res[8].rows[0]
          ec1.series = ec1.series.map(item => {
            return {
              data: item.data,
              name: item.name,
              color: item.name == '未解决' ? '#ffc747' : item.name == '已解决' ? '#3cb3ff' : '#ff476b'
            }
          })
          this.shijianEc = ec1
          //处理 生活服务echarts数据
          var ec2 = res[9].rows[0]
          ec2.color = ec2.series.map(item => {
            return item.color
          })
          ec2.series = ec2.series.map(item => {
            return {
              name:item.name,
              value:item.data[0]
            }
          })
          console.log(ec2)
          this.fuwuEc = ec2
        })
      },
      getInfo() {
        return new Promise((resolve, reject) => {
          var url = that.urlobj.getShouye('info')
          that.$get(url).then(res => {
            if (res.isSucceed) {
              resolve(res)
            } else {
              reject(res)
            }
          }).catch(e => {
            reject(e)
          })
        })
      },
      getCount() {
        return new Promise((resolve, reject) => {
          var url = that.urlobj.getShouye('count')
          that.$get(url).then(res => {
            if (res.isSucceed) {
              resolve(res)
            } else {
              reject(res)
            }
          }).catch(e => {
            reject(e)
          })
        })
      },
      getScore() {
        return new Promise((resolve, reject) => {
          var url = that.urlobj.getShouye('score')
          that.$get(url).then(res => {
            if (res.isSucceed) {
              resolve(res)
            } else {
              reject(res)
            }
          }).catch(e => {
            reject(e)
          })
        })
      },
      getParty() {
        return new Promise((resolve, reject) => {
          var url = that.urlobj.getShouye('party')
          that.$get(url).then(res => {
            if (res.isSucceed) {
              resolve(res)
            } else {
              reject(res)
            }
          }).catch(e => {
            reject(e)
          })
        })
      },
      getEvent() {
        return new Promise((resolve, reject) => {
          var url = that.urlobj.getShouye('event')
          that.$get(url).then(res => {
            if (res.isSucceed) {
              resolve(res)
            } else {
              reject(res)
            }
          }).catch(e => {
            reject(e)
          })
        })
      },
      getPartyMes() {
        return new Promise((resolve, reject) => {
          var url = that.urlobj.getShouye('party_message')
          that.$get(url).then(res => {
            if (res.isSucceed) {
              resolve(res)
            } else {
              reject(res)
            }
          }).catch(e => {
            reject(e)
          })
        })
      },
      getEventReport() {
        return new Promise((resolve, reject) => {
          var url = that.urlobj.getShouye('event_report')
          that.$get(url).then(res => {
            if (res.isSucceed) {
              resolve(res)
            } else {
              reject(res)
            }
          }).catch(e => {
            reject(e)
          })
        })
      },
      getActive() {
        return new Promise((resolve, reject) => {
          var url = this.urlobj.getPartyActive;
          this.$get(url, {
            zoneId: '-1'
          }).then(res => {
            resolve(res)

          }).catch(e => {
            reject(e)
          })
        })
      },
      getShijianEc() {
        return new Promise((resolve, reject) => {
          var url = that.urlobj.getShouyeEc('event')
          that.$get(url).then(res => {
            if (res.isSucceed) {
              resolve(res)
            } else {
              reject(res)
            }
          }).catch(e => {
            reject(e)
          })
        })
      },
      getFuwuEc() {
        return new Promise((resolve, reject) => {
          var url = that.urlobj.getShouyeEc('service')
          that.$get(url).then(res => {
            if (res.isSucceed) {
              resolve(res)
            } else {
              reject(res)
            }
          }).catch(e => {
            reject(e)
          })
        })
      }
    },
  }
</script>

<style scoped>
  .margin-all {
    margin: 17.5px
  }

  .margin-top {
    margin-top: 17.5px
  }

  .margin-bottom {
    margin-bottom: 17.5px;
  }

  .margin-left {
    margin-left: 17.5px;
  }

  .margin-right {
    margin-right: 17.5px;
  }

  .box-btw {
    justify-content: space-between
  }

  .isMin {
    overflow: scroll;
  }
</style>
